  /**
   * Campaign Landing — same-page vehicle search + safe filter updates.
   * Updates only the product grid and filter form; never replaces the section.
   */
  (function () {
    'use strict';

    var F_BRAND = 'filter.p.m.custom.brand';
    var F_MODEL = 'filter.p.m.custom.model';
    var F_BODYSTYLE = 'filter.p.m.custom.body_style';
    var F_YEAR = 'filter.p.m.custom.year_range';
    var F_ENGINE = 'filter.p.m.custom.engines';
    var FILTER_KEYS = [F_BRAND, F_MODEL, F_BODYSTYLE, F_YEAR, F_ENGINE];
    var CAMPAIGN_SEARCH_Q = '*';
    var CAMPAIGN_SEARCH_TYPE = 'product';

    var BRAND_COLLECTION_HANDLE_BY_INITIAL = {
      A: 'vehicle-finder-a-brands',
      B: 'vehicle-finder-b-c-brands',
      C: 'vehicle-finder-b-c-brands',
      D: 'vehicle-finder-d-l-brands',
      E: 'vehicle-finder-d-l-brands',
      F: 'vehicle-finder-d-l-brands',
      G: 'vehicle-finder-d-l-brands',
      H: 'vehicle-finder-d-l-brands',
      I: 'vehicle-finder-d-l-brands',
      J: 'vehicle-finder-d-l-brands',
      K: 'vehicle-finder-d-l-brands',
      L: 'vehicle-finder-d-l-brands',
      M: 'vehicle-finder-m-brands',
      N: 'vehicle-finder-n-r-brands',
      O: 'vehicle-finder-n-r-brands',
      P: 'vehicle-finder-n-r-brands',
      Q: 'vehicle-finder-n-r-brands',
      R: 'vehicle-finder-n-r-brands',
      S: 'vehicle-finder-s-brands',
      T: 'vehicle-finder-t-brands',
      V: 'vehicle-finder-v-w-brands',
      W: 'vehicle-finder-v-w-brands'
    };

    var loading = false;
    var pendingFilterRequest = null;
    var paginationBound = false;
    var filterUiBound = false;
    var filterPatchApplied = false;
    var initialized = false;
    var rerenderBound = false;
    var campaignMobileFilterUiBound = false;
    var campaignDrawerClicksBound = false;
    var campaignDeferredFiltersBound = false;
    var campaignFilterFormSnapshot = null;
    var campaignFilterApplying = false;
    var campaignPendingAccordionState = null;
    var campaignDrawerFacetSyncBound = false;
    var campaignPreviewCountTimer = null;
    var campaignPreviewCountRequest = 0;
    var campaignLastPreviewCount = '';
    var campaignPreviewCascadeInProgress = false;
    var campaignMobileDrawerControlsBound = false;
    var campaignSuppressBackdropCloseUntil = 0;
    var CAMPAIGN_MOBILE_MEDIA = '(max-width: 1023px)';
    var FACET_REMOVE_ICON =
      '<span class="m-active-facets--remove-icon">' +
      '<svg class="m-svg-icon" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">' +
      '<path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>' +
      '</svg></span>';

    function getListing() {
      return document.getElementById('listing');
    }

    function getSection() {
      return document.querySelector('.campaign-landing-plp');
    }

    function ensureCollectionController() {
      if (typeof MinimogTheme === 'undefined') {
        window.MinimogTheme = {};
      }
      if (!MinimogTheme.Collection && typeof Collection !== 'undefined') {
        MinimogTheme.Collection = new Collection();
      }
      return MinimogTheme.Collection || null;
    }

    function isCustomFilterMode() {
      var listing = getListing();
      return listing && listing.dataset.campaignFilterMode === 'custom';
    }

    function scrollToListing() {
      var el = document.getElementById('listing');
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - 12;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function usesSearchCatalog() {
      var listing = getListing();
      return listing && listing.dataset.campaignCatalogSource === 'search';
    }

    function resolveCatalogPath(searchParams) {
      if (!usesSearchCatalog()) {
        var listing = getListing();
        return listing?.dataset.defaultCollectionPath || '/collections/all-products';
      }

      var params = new URLSearchParams(searchParams || '');
      var brand = params.get(F_BRAND) || '';
      if (!brand) return '/search';

      var initialMatch = brand.match(/[A-Za-z]/);
      if (!initialMatch) return '/search';

      var handle = BRAND_COLLECTION_HANDLE_BY_INITIAL[initialMatch[0].toUpperCase()];
      return handle ? '/collections/' + handle : '/search';
    }

    function normalizeCampaignSearchParams(searchParams) {
      if (!usesSearchCatalog()) return searchParams || '';

      var catalogPath = resolveCatalogPath(searchParams);
      var params = new URLSearchParams(searchParams || '');

      if (catalogPath === '/search') {
        if (!params.get('q')) params.set('q', CAMPAIGN_SEARCH_Q);
        if (!params.get('type')) params.set('type', CAMPAIGN_SEARCH_TYPE);
      } else {
        params.delete('q');
        params.delete('type');
        params.delete('options[prefix]');
      }

      return params.toString();
    }

    function hasVehicleFilters(searchParams) {
      if (!searchParams) return false;
      var params = new URLSearchParams(searchParams);
      return FILTER_KEYS.some(function (key) {
        return params.has(key);
      });
    }

    function hasAnyFilterParams(searchParams) {
      if (!searchParams) return false;
      var params = new URLSearchParams(searchParams);
      var found = false;
      params.forEach(function (_value, key) {
        if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'page') {
          found = true;
        }
      });
      return found;
    }

  function buildFetchUrls(catalogPath, searchParams) {
    var listing = getListing();
    var primarySectionId = listing?.dataset.proxySectionId || 'main';
    var normalizedParams = normalizeCampaignSearchParams(searchParams);
    var urls = [];

    if (normalizedParams) {
      urls.push(
        catalogPath + '?' + normalizedParams + '&section_id=' + encodeURIComponent(primarySectionId)
      );
      urls.push(catalogPath + '?' + normalizedParams);
    } else {
      urls.push(catalogPath + '?section_id=' + encodeURIComponent(primarySectionId));
      urls.push(catalogPath);
    }

    return urls;
  }

  function getFormFilterSearchParams(form) {
    if (!form) return '';
    return normalizeCampaignSearchParams(new URLSearchParams(new FormData(form)).toString());
  }

  function normalizeParamsForCompare(paramString) {
    var params = new URLSearchParams(paramString || '');
    var keys = [];
    params.forEach(function (_value, key) {
      keys.push(key);
    });
    keys.sort();
    var parts = [];
    keys.forEach(function (key) {
      params.getAll(key).sort().forEach(function (value) {
        parts.push(key + '=' + value);
      });
    });
    return parts.join('&');
  }

  function pendingFiltersDifferFromApplied(form) {
    return (
      normalizeParamsForCompare(getFormFilterSearchParams(form)) !==
      normalizeParamsForCompare(getActiveSearchParams())
    );
  }

  function isValidCampaignPreviewDoc(doc) {
    if (!doc) return false;
    if (doc.querySelector('[data-koni-plp-results-count]')) return true;
    if (doc.querySelector('.m-collection--empty')) return true;
    return !!(doc.getElementById('CollectionProductGrid') && doc.getElementById('CollectionFiltersForm'));
  }

    function parseFetchedHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach(function (script) {
        script.remove();
      });
      return doc;
    }

    var FILTER_SCRIPT_PATTERN = /(storefont-filters|price-range|facet-remove)\.js/i;

    function stripScriptsFromHtml(html) {
      if (!html) return '';
      var template = document.createElement('template');
      template.innerHTML = html;
      template.content.querySelectorAll('script').forEach(function (script) {
        script.remove();
      });
      return template.innerHTML;
    }

    function removeDuplicateFilterScripts() {
      var seen = {};
      document.querySelectorAll('script[src]').forEach(function (script) {
        var src = script.getAttribute('src') || '';
        if (!FILTER_SCRIPT_PATTERN.test(src)) return;

        var key = src.split('?')[0];
        if (seen[key]) {
          script.remove();
          return;
        }
        seen[key] = true;
      });

      document
        .querySelectorAll('.koni-plp-filters__wrapper script, collection-filters-form script, #CollectionFiltersForm script')
        .forEach(function (script) {
          script.remove();
        });
    }

    function hasLiquidErrorMarkup(node) {
      if (!node) return true;
      var text = node.textContent || '';
      return /Liquid error/i.test(text);
    }

    function injectProductGrid(doc) {
      var newGrid = doc.getElementById('CollectionProductGrid');
      var currentGrid = document.getElementById('CollectionProductGrid');
      if (!newGrid || !currentGrid) return false;
      if (hasLiquidErrorMarkup(newGrid)) return false;

      // Keep a single ActiveFacets host in the campaign topbar.
      newGrid.querySelectorAll('#ActiveFacets').forEach(function (el) {
        el.remove();
      });

      currentGrid.innerHTML = newGrid.innerHTML;
      return true;
    }

    function getFacetsHost() {
      var grid = document.getElementById('CollectionProductGrid');
      if (!grid) return null;

      var host = grid.querySelector('.campaign-landing-plp__facets-host');
      if (!host) {
        host = document.createElement('div');
        host.className = 'campaign-landing-plp__facets-host';
        var toolbar = grid.querySelector('.koni-plp-collection-toolbar');
        if (toolbar) {
          toolbar.insertAdjacentElement('afterend', host);
        } else {
          grid.prepend(host);
        }
      }
      return host;
    }

    function snapshotCampaignAccordionState() {
      var wrapper = document.querySelector('.campaign-landing-plp .koni-plp-filters__wrapper');
      if (!wrapper) return [];

      return Array.from(wrapper.querySelectorAll('.m-filter--widget.m-accordion--item')).map(function (item, index) {
        return {
          index: item.dataset.index || String(index + 1),
          open: item.classList.contains('open')
        };
      });
    }

    function restoreCampaignAccordionState(state) {
      if (!state || !state.length) return;

      var wrapper = document.querySelector('.campaign-landing-plp .koni-plp-filters__wrapper');
      if (!wrapper) return;

      state.forEach(function (entry) {
        var item = wrapper.querySelector('.m-accordion--item[data-index="' + entry.index + '"]');
        if (!item) return;
        item.classList.toggle('open', !!entry.open);
        syncCampaignAccordionPanel(item);
      });
    }

    function expandCampaignFilterAccordions() {
      var wrapper = document.querySelector('.campaign-landing-plp .koni-plp-filters__wrapper');
      if (!wrapper) return;

      var isMobile = isCampaignMobileFilters();
      var seedMobileAccordions = isMobile && wrapper.dataset.campaignAccordionsSeeded !== 'true';

      wrapper.querySelectorAll('.m-filter--widget.m-accordion--item').forEach(function (item) {
        if (!isMobile || seedMobileAccordions) {
          item.classList.add('open');
        }

        var content = item.querySelector('.m-accordion--item-content');
        if (!content || !item.classList.contains('open')) return;

        if (!isMobile) {
          content.style.opacity = '1';
        } else {
          content.style.removeProperty('opacity');
        }
        content.classList.remove('max-height-set');
        content.style.removeProperty('max-height');
      });

      if (seedMobileAccordions) {
        wrapper.dataset.campaignAccordionsSeeded = 'true';
      }

      var section = document.querySelector('.campaign-landing-plp');
      if (typeof KoniPlp !== 'undefined' && KoniPlp.fixFilterAccordionHeights && !isMobile) {
        KoniPlp.fixFilterAccordionHeights(section);
      }
      if (!isMobile) {
        window.MinimogTheme?.Collection?.accordions?.setContentHeight?.();
      }
    }

    function syncCampaignAccordionPanel(item) {
      if (!item) return;
      var content = item.querySelector('.m-accordion--item-content');
      if (!content) return;

      if (item.classList.contains('open')) {
        content.style.removeProperty('opacity');
        content.style.removeProperty('max-height');
        content.classList.remove('max-height-set');
      } else {
        content.style.removeProperty('opacity');
        content.style.removeProperty('max-height');
        content.classList.remove('max-height-set');
      }
    }

    function bindCampaignFilterAccordionToggles() {
      var wrapper = document.querySelector('.campaign-landing-plp .koni-plp-filters__wrapper');
      if (!wrapper || wrapper.dataset.campaignAccordionBound === 'true') return;
      wrapper.dataset.campaignAccordionBound = 'true';

      wrapper.addEventListener('click', function (event) {
        if (!isCampaignMobileFilters()) return;

        var button = event.target.closest('.m-accordion--item-button');
        if (!button) return;

        var item = button.closest('.m-filter--widget.m-accordion--item');
        if (!item) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        item.classList.toggle('open');
        syncCampaignAccordionPanel(item);
      }, true);
    }

    function injectFilterForm(doc, options) {
      options = options || {};
      var newForm = doc.getElementById('CollectionFiltersForm');
      if (!newForm) return false;

      if (isCustomFilterMode()) {
        var currentCustom =
          document.getElementById('CampaignFiltersForm') ||
          document.querySelector('[data-campaign-filters-form]');
        if (currentCustom) {
          currentCustom.innerHTML = stripScriptsFromHtml(newForm.innerHTML);
        }
      } else {
        var currentForm = document.getElementById('CollectionFiltersForm');
        var mobileAccordionState = isCampaignMobileFilters() ? snapshotCampaignAccordionState() : null;
        if (currentForm) {
          currentForm.innerHTML = stripScriptsFromHtml(newForm.innerHTML);
        } else {
          ensureStorefrontFilterHost(newForm);
        }
        if (isCampaignMobileFilters()) {
          if (campaignPendingAccordionState) {
            restoreCampaignAccordionState(campaignPendingAccordionState);
            campaignPendingAccordionState = null;
          } else if (mobileAccordionState && mobileAccordionState.length) {
            restoreCampaignAccordionState(mobileAccordionState);
          } else {
            expandCampaignFilterAccordions();
          }
        }
      }

      var newFacets = doc.getElementById('ActiveFacets');
      var facetsHost = getFacetsHost();
      if (newFacets && facetsHost) {
        var existing = facetsHost.querySelector('#ActiveFacets');
        if (existing) {
          existing.innerHTML = stripScriptsFromHtml(newFacets.innerHTML);
        } else {
          var clone = newFacets.cloneNode(true);
          clone.id = 'ActiveFacets';
          clone.querySelectorAll('script').forEach(function (script) {
            script.remove();
          });
          facetsHost.innerHTML = '';
          facetsHost.appendChild(clone);
        }
      }

      // Remove duplicate facet blocks from the product grid.
      document.querySelectorAll('#CollectionProductGrid #ActiveFacets').forEach(function (el) {
        if (!facetsHost || !facetsHost.contains(el)) {
          el.remove();
        }
      });
      relocateCampaignFacets();

      updateClearAllLink(doc);
      revealFilterSidebar();

      var wrapper = document.querySelector('.koni-plp-filters__wrapper');
      if (wrapper) {
        wrapper.querySelectorAll('script').forEach(function (script) {
          script.remove();
        });
      }

      if (!isCampaignMobileFilters()) {
        expandCampaignFilterAccordions();
      }
      bindCampaignFilterAccordionToggles();
      removeDuplicateFilterScripts();
      patchAllFilterInstances();
      if (!options.fromMobilePreview) {
        syncCampaignMobileFilterUi();
      }

      return true;
    }

    function dedupeActiveFacets() {
      var facets = Array.from(document.querySelectorAll('#ActiveFacets'));
      if (facets.length <= 1) return;

      var host = getFacetsHost();
      var keep = (host && host.querySelector('#ActiveFacets')) || facets[0];
      facets.forEach(function (el) {
        if (el !== keep) el.remove();
      });
    }

    function ensureStorefrontFilterHost(newForm) {
      var wrapper = document.querySelector('.koni-plp-filters__wrapper');
      if (!wrapper) return;

      wrapper.querySelectorAll('script').forEach(function (script) {
        script.remove();
      });

      var host = document.createElement('collection-filters-form');
      host.className = 'm-collection-filters-form m-filter--widget';
      var form = document.createElement('form');
      form.id = 'CollectionFiltersForm';
      form.innerHTML = stripScriptsFromHtml(newForm.innerHTML);
      host.appendChild(form);

      var existing = wrapper.querySelector('collection-filters-form');
      if (existing) {
        existing.replaceWith(host);
      } else {
        wrapper.appendChild(host);
      }

      patchFilterComponent();
    }

    function revealFilterSidebar() {
      var sidebar = document.querySelector('.koni-plp-filters-sidebar');
      if (sidebar) {
        sidebar.classList.remove('m:hidden');
      }

      var section = getSection();
      if (section) {
        section.dataset.enableFilters = 'true';
        var wrapper = section.querySelector('.m-collection--wrapper');
        if (wrapper && !wrapper.classList.contains('m-sidebar--leftColumn') && !wrapper.classList.contains('m-sidebar--rightColumn') && !wrapper.classList.contains('m-sidebar--fixed')) {
          wrapper.classList.add('m-sidebar--leftColumn');
        }
      }
    }

    function needsFilterHydration() {
      var form =
        document.getElementById('CollectionFiltersForm') ||
        document.getElementById('CampaignFiltersForm') ||
        document.querySelector('[data-campaign-filters-form]');
      if (!form) return true;
      return form.querySelectorAll('.m-filter--widget, .m-facet--item, input[type="checkbox"]').length === 0;
    }

    function getDefaultHydrationParams() {
      var stored = getActiveSearchParams();
      if (stored) {
        if (hasAnyFilterParams(stored) || usesSearchCatalog()) {
          return normalizeCampaignSearchParams(stored);
        }
      }

      var urlParams = new URLSearchParams(window.location.search);
      if (hasAnyFilterParams(urlParams.toString())) {
        return normalizeCampaignSearchParams(urlParams.toString());
      }

      if (usesSearchCatalog()) {
        return normalizeCampaignSearchParams('');
      }

      return '';
    }

    function updateClearAllLink(doc) {
      var listing = getListing();
      if (!listing) return;

      var currentClear = listing.querySelector('.koni-plp-filters__clear');
      var newClear = doc.querySelector('.koni-plp-filters__clear');
      var header = listing.querySelector('.koni-plp-filters__header');

      if (newClear && currentClear) {
        currentClear.replaceWith(newClear.cloneNode(true));
      } else if (newClear && !currentClear && header) {
        var title = header.querySelector('.koni-plp-filters__title');
        if (title) {
          title.insertAdjacentElement('afterend', newClear.cloneNode(true));
        } else {
          header.prepend(newClear.cloneNode(true));
        }
      } else if (!newClear && currentClear) {
        currentClear.remove();
      }
    }

    function showGridLoading(isLoading) {
      var grid = document.getElementById('CollectionProductGrid');
      if (!grid) return;
      grid.classList.toggle('campaign-plp-loading', isLoading);

      var sidebar = document.querySelector('.koni-plp-filters-sidebar');
      if (sidebar) {
        sidebar.classList.toggle('campaign-plp-loading', isLoading);
      }
    }

    function fetchCampaignMarkup(searchParams) {
      var normalizedParams = normalizeCampaignSearchParams(searchParams);
      var catalogPath = resolveCatalogPath(normalizedParams);
      var urls = buildFetchUrls(catalogPath, normalizedParams);

      function tryFetch(index) {
        if (index >= urls.length) {
          return Promise.reject(new Error('Failed to load campaign products'));
        }

        return fetch(urls[index], { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load campaign products');
            return res.text();
          })
          .then(function (html) {
            var doc = parseFetchedHtml(html);
            if (!injectProductGrid(doc)) {
              throw new Error('Product grid markup missing');
            }
            injectFilterForm(doc);
          })
          .catch(function () {
            return tryFetch(index + 1);
          });
      }

      return tryFetch(0);
    }

    function updateBrowserState(searchParams, usePush) {
      var url = window.location.pathname;
      var state = { searchParams: searchParams || '' };

      if (usePush) {
        history.pushState(state, '', url);
      } else {
        history.replaceState(state, '', url);
      }
    }

    function stripListingHash() {
      if (window.location.hash === '#listing') {
        history.replaceState(history.state, '', window.location.pathname);
      }
    }

    function afterGridUpdate() {
      if (typeof handleBackgroundImageLazyload === 'function') {
        handleBackgroundImageLazyload();
      }
      var collection = ensureCollectionController();
      if (collection) {
        collection.init();
      }
      if (typeof KoniPlp !== 'undefined') {
        KoniPlp.init();
      }

      function restoreMobileAccordions() {
        if (isCampaignMobileFilters() && campaignPendingAccordionState) {
          restoreCampaignAccordionState(campaignPendingAccordionState);
          campaignPendingAccordionState = null;
        } else if (!isCampaignMobileFilters()) {
          expandCampaignFilterAccordions();
        }
      }

      restoreMobileAccordions();
      requestAnimationFrame(restoreMobileAccordions);
      bindCampaignFilterAccordionToggles();

      var filtersForm = document.querySelector('collection-filters-form');
      if (filtersForm && typeof filtersForm.bindFilterScrollListeners === 'function') {
        filtersForm.bindFilterScrollListeners();
      }

      relocateCampaignFacets();
      dedupeActiveFacets();
      removeDuplicateFilterScripts();
      bindCustomFilters();
      patchAllFilterInstances();
      document.dispatchEvent(new CustomEvent('collection:rerendered'));
      syncCampaignMobileFilterUi();

      // Grid HTML swap replaces the Compare toggle; keep mode only if user enabled it.
      if (window.MinimogTheme && MinimogTheme.CompareProduct) {
        var cp = MinimogTheme.CompareProduct;
        cp.setCompareButtonsState();
        if (cp.isCompareMode()) {
          cp.setCompareMode(true, true);
        } else {
          cp.setCompareMode(false, true);
        }
      }
    }

    function loadFilteredResults(searchParams, options) {
      searchParams = normalizeCampaignSearchParams(searchParams);

      if (loading) {
        pendingFilterRequest = { searchParams: searchParams || '', options: options || {} };
        return Promise.resolve();
      }
      loading = true;
      showGridLoading(true);

      return fetchCampaignMarkup(searchParams || '')
        .then(function () {
          updateBrowserState(searchParams || '', !!(options && options.pushState));
          afterGridUpdate();
          if (options && options.scroll) {
            scrollToListing();
          }
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          loading = false;
          showGridLoading(false);

          if (pendingFilterRequest) {
            var pending = pendingFilterRequest;
            pendingFilterRequest = null;
            loadFilteredResults(pending.searchParams, pending.options);
          }
        });
    }

    function applyVehicleSearch(queryString, options) {
      var mergedOptions = Object.assign({}, options || {}, { pushState: true, scroll: true });
      return loadFilteredResults(queryString || '', mergedOptions);
    }

    function getActiveSearchParams() {
      if (history.state && typeof history.state.searchParams === 'string') {
        return history.state.searchParams;
      }
      return '';
    }

    function mergeSearchParams(baseParams, linkSearch) {
      var merged = new URLSearchParams(baseParams || '');
      var linkParams = new URLSearchParams(linkSearch || '');
      linkParams.forEach(function (value, key) {
        merged.set(key, value);
      });
      return merged.toString();
    }

    function debounce(fn, wait) {
      var timer;
      return function () {
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      };
    }

    function bindPagination() {
      var listing = getListing();
      if (!listing || paginationBound) return;
      paginationBound = true;

      listing.addEventListener('click', function (event) {
        var link = event.target.closest('.m-collection--pagination a[href]');
        if (!link) return;

        event.preventDefault();
        try {
          var url = new URL(link.href, window.location.origin);
          var merged = mergeSearchParams(getActiveSearchParams(), url.search);
          loadFilteredResults(normalizeCampaignSearchParams(merged), { scroll: true, pushState: true });
        } catch (err) {
          console.error(err);
        }
      });
    }

    function bindFilterUiGuards() {
      var listing = getListing();
      if (!listing || filterUiBound) return;
      filterUiBound = true;

      listing.addEventListener('click', function (event) {
        var clearLink = event.target.closest('.koni-plp-filters__clear');
        if (clearLink) {
          event.preventDefault();
          loadFilteredResults('', { pushState: true, scroll: true });
          return;
        }

        var facetLink = event.target.closest('#ActiveFacets a[href], facet-remove a[href]');
        if (facetLink) {
          event.preventDefault();
          try {
            var url = new URL(facetLink.href, window.location.origin);
            loadFilteredResults(normalizeCampaignSearchParams(url.searchParams.toString()), { pushState: true, scroll: false });
          } catch (err) {
            console.error(err);
          }
        }
      });
    }

    function patchFilterInstance(instance) {
      if (!instance || instance.__campaignInstancePatched || !getListing() || isCustomFilterMode()) {
        return;
      }

      instance.__campaignOriginalRenderPage = instance.renderPage;
      instance.__campaignOriginalRenderProductGrid = instance.renderProductGrid;
      instance.__campaignOriginalUpdateURLHash = instance.updateURLHash;
      instance.__campaignOriginalRestoreFilterScrollState = instance.restoreFilterScrollState;

      instance.restoreFilterScrollState = function (state) {
        if (!getListing() || !isCampaignMobileFilters()) {
          return instance.__campaignOriginalRestoreFilterScrollState.call(this, state);
        }

        var sidebarContent = this.domNodes && this.domNodes.sidebarContent;
        if (sidebarContent && state && state.sidebarScrollY) {
          sidebarContent.scrollTop = state.sidebarScrollY;
        }
      };

      instance.renderPage = function (searchParams, updateURLHash) {
        if (!getListing()) {
          return instance.__campaignOriginalRenderPage.call(this, searchParams, updateURLHash);
        }

        if (isCampaignMobileFilters() && !this.__campaignApplyFiltersNow && updateURLHash !== false) {
          return Promise.resolve();
        }

        var filterScrollState = typeof this.saveFilterScrollState === 'function'
          ? this.saveFilterScrollState()
          : null;

        if (this.loading && typeof this.loading.start === 'function') {
          this.loading.start();
        }

        var self = this;
        loadFilteredResults(searchParams || '', { pushState: updateURLHash !== false })
          .then(function () {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                if (typeof self.restoreFilterScrollState === 'function') {
                  self.restoreFilterScrollState(filterScrollState);
                }
                if (self.loading && typeof self.loading.finish === 'function') {
                  self.loading.finish(function () {
                    if (typeof self.finishFilterUpdate === 'function') {
                      self.finishFilterUpdate(filterScrollState);
                    }
                  });
                }
              });
            });
          });
      };

      instance.renderProductGrid = function (html) {
        if (!getListing()) {
          return instance.__campaignOriginalRenderProductGrid.call(this, html);
        }
      };

      instance.updateURLHash = function (searchParams) {
        if (!getListing()) {
          return instance.__campaignOriginalUpdateURLHash.call(this, searchParams);
        }
        updateBrowserState(searchParams || '', true);
      };

      instance.__campaignInstancePatched = true;
    }

    function patchAllFilterInstances() {
      document.querySelectorAll('collection-filters-form').forEach(patchFilterInstance);
    }

    function patchFilterComponent() {
      if (isCustomFilterMode()) return;

      var FilterCtor = customElements.get('collection-filters-form');
      if (!FilterCtor) {
        setTimeout(patchFilterComponent, 50);
        return;
      }

      if (!FilterCtor.prototype.__campaignSubmitPatched) {
        var originalSubmit = FilterCtor.prototype.onSubmitHandler;
        FilterCtor.prototype.onSubmitHandler = function (event) {
          if (getListing() && isCampaignMobileFilters() && !this.__campaignApplyFiltersNow) {
            event.preventDefault();
            return;
          }
          return originalSubmit.call(this, event);
        };
        FilterCtor.prototype.__campaignSubmitPatched = true;
      }

      if (!FilterCtor.prototype.__campaignConnectedPatched) {
        var originalConnected = FilterCtor.prototype.connectedCallback;
        FilterCtor.prototype.connectedCallback = function () {
          if (originalConnected) {
            originalConnected.call(this);
          }
          patchFilterInstance(this);
        };
        FilterCtor.prototype.__campaignConnectedPatched = true;
      }

      patchAllFilterInstances();
      filterPatchApplied = true;
    }

    function bindCustomFilters() {
      if (!isCustomFilterMode()) return;

      var form = document.getElementById('CampaignFiltersForm') || document.querySelector('[data-campaign-filters-form]');
      if (!form) return;

      if (form.dataset.campaignBound === 'true') return;
      form.dataset.campaignBound = 'true';

      var onChange = debounce(function () {
        var formData = new FormData(form);
        var params = new URLSearchParams(formData).toString();
        loadFilteredResults(params, { pushState: true, scroll: false });
      }, 300);

      form.addEventListener('input', onChange);
      form.addEventListener('change', onChange);

      var toolbarSort = document.querySelector('[data-toolbar-sorting] select');
      if (toolbarSort && toolbarSort.dataset.campaignBound !== 'true') {
        toolbarSort.dataset.campaignBound = 'true';
        toolbarSort.addEventListener('change', function () {
          var formData = new FormData(form);
          formData.set('sort_by', toolbarSort.value);
          loadFilteredResults(new URLSearchParams(formData).toString(), {
            pushState: true,
            scroll: false
          });
        });
      }
    }

    function relocateCampaignFacets() {
      var grid = document.getElementById('CollectionProductGrid');
      if (!grid) return;

      var facetsHost = getFacetsHost();
      var toolbar = grid.querySelector('.koni-plp-collection-toolbar');
      if (toolbar && facetsHost && toolbar.nextElementSibling !== facetsHost) {
        toolbar.insertAdjacentElement('afterend', facetsHost);
      }

      var orphanFacets = Array.from(document.querySelectorAll('#ActiveFacets')).filter(function (el) {
        return facetsHost && !facetsHost.contains(el);
      });

      if (orphanFacets.length && facetsHost) {
        var primary = orphanFacets[0];
        var existing = facetsHost.querySelector('#ActiveFacets');
        if (existing) {
          existing.innerHTML = primary.innerHTML;
          orphanFacets.forEach(function (el) {
            el.remove();
          });
        } else {
          facetsHost.appendChild(primary);
          orphanFacets.slice(1).forEach(function (el) {
            el.remove();
          });
        }
      }

      dedupeActiveFacets();
      syncCampaignMobileFilterUi();
    }

    function isCampaignMobileFilters() {
      return getListing() && window.matchMedia(CAMPAIGN_MOBILE_MEDIA).matches;
    }

    function hasActiveFacetItems(activeFacetsEl) {
      if (!activeFacetsEl) return false;
      return !!activeFacetsEl.querySelector('.m-active-facets--item:not(.m-active-facets--item-remove-all)');
    }

    function parseResultsCountText(text) {
      if (!text) return '';
      var normalized = String(text).trim();
      var match =
        normalized.match(/of\s+(\d[\d,]*)/i) ||
        normalized.match(/(\d[\d,]*)\s+products?/i) ||
        normalized.match(/(\d[\d,]*)\s+results?/i) ||
        normalized.match(/\(\s*(\d[\d,]*)\s*\)/);
      return match ? match[1].replace(/,/g, '') : '';
    }

    function parseResultsTotalCount() {
      var resultsEl = document.querySelector('.campaign-landing-plp [data-koni-plp-results-count]');
      if (!resultsEl) return '';
      return parseResultsCountText(resultsEl.textContent);
    }

  function parseCountFromFetchedDoc(doc) {
    if (!doc) return '';

    var resultsEl = doc.querySelector('[data-koni-plp-results-count]');
    if (resultsEl) {
      var parsed = parseResultsCountText(resultsEl.textContent);
      if (parsed) return parsed;
    }

    if (doc.querySelector('.m-collection--empty')) {
      return '0';
    }

    var section = doc.querySelector('[data-product-count]:not(.campaign-landing-plp)');
    if (section && section.dataset.productCount) {
      return String(section.dataset.productCount).replace(/,/g, '');
    }

    var grid = doc.getElementById('CollectionProductGrid');
    if (grid) {
      var sectionInGrid = grid.closest('[data-product-count]:not(.campaign-landing-plp)');
      if (sectionInGrid && sectionInGrid.dataset.productCount) {
        return String(sectionInGrid.dataset.productCount).replace(/,/g, '');
      }
    }

    return '';
  }

  function getInstantPreviewCountFromForm(form) {
    if (!form) return '';

    var checked = Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).filter(function (input) {
      return !input.disabled;
    });

    if (checked.length !== 1) return '';

    var countNode = checked[0].closest('.m-facet--item');
    if (!countNode) return '';

    var countText = countNode.querySelector('.m-facet--product-count');
    if (!countText) return '';

    var match = countText.textContent.match(/\(\s*(\d[\d,]*)\s*\)/);
    return match ? match[1].replace(/,/g, '') : '';
  }

  function updateCampaignShowMoreLabel(btn, widget) {
    if (!btn || !widget) return;

    var labelNode = widget.querySelector('.m-filter--widget-title span');
    var label = labelNode && labelNode.textContent ? labelNode.textContent.trim() : 'options';

    if (widget.classList.contains('koni-plp-filter--expanded')) {
      btn.hidden = false;
      btn.textContent = 'Show less ' + label.toLowerCase();
      return;
    }

    var remaining = widget.querySelectorAll('.koni-plp-facet--more').length;
    if (remaining <= 0) {
      btn.hidden = true;
      return;
    }

    btn.hidden = false;
    btn.textContent = 'Show more ' + label.toLowerCase() + ' (' + remaining + ')';
  }

  function clearCampaignAccordionContentConstraints(widget) {
    if (!widget) return;

    var content = widget.querySelector('.m-accordion--item-content');
    if (!content) return;

    content.style.removeProperty('max-height');
    content.style.removeProperty('overflow');
    content.style.removeProperty('opacity');
    content.classList.remove('max-height-set');
  }

  function bindCampaignMobileFilterShowMore() {
    var wrapper = document.querySelector('.campaign-landing-plp .koni-plp-filters__wrapper');
    if (!wrapper || wrapper.dataset.campaignShowMoreBound === 'true') return;
    wrapper.dataset.campaignShowMoreBound = 'true';

    wrapper.addEventListener(
      'click',
      function (event) {
        if (!isCampaignMobileFilters()) return;

        var btn = event.target.closest('[data-koni-filter-show-more]');
        if (!btn) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var widget = btn.closest('.m-filter--widget.m-accordion--item');
        if (!widget || typeof KoniPlp === 'undefined') return;

        var initialVisible = 5;
        var contextRadius = 3;
        var items = KoniPlp.getFilterFacetItems(widget);

        if (widget.classList.contains('koni-plp-filter--expanded')) {
          KoniPlp.collapseFilterFacetVisibility(widget, items, initialVisible, contextRadius);
        } else {
          KoniPlp.expandFilterFacetVisibility(widget);
        }

        updateCampaignShowMoreLabel(btn, widget);
        clearCampaignAccordionContentConstraints(widget);

        if (typeof KoniPlp.fixFilterAccordionHeights === 'function') {
          KoniPlp.fixFilterAccordionHeights(widget.closest('.koni-plp-section'));
        }
      },
      true
    );
  }

  function bindCampaignMobileFilters() {
    if (!isCampaignMobileFilters() || typeof KoniPlp === 'undefined') return;

    bindCampaignMobileFilterShowMore();

    var section = document.querySelector('.campaign-landing-plp');
    if (!section) return;

    if (typeof KoniPlp.fixFilterAccordionHeights === 'function') {
      KoniPlp.fixFilterAccordionHeights(section);
    }

    if (typeof KoniPlp.bindFilterGroupScrollIsolation === 'function') {
      KoniPlp.bindFilterGroupScrollIsolation(section);
    }

    section.querySelectorAll('.m-filter--widget.m-accordion--item').forEach(function (widget) {
      KoniPlp.setupFilterShowMore(widget);
      var btn = widget.querySelector('[data-koni-filter-show-more]');
      if (btn) {
        btn.onclick = null;
        updateCampaignShowMoreLabel(btn, widget);
      }
    });
  }

  function patchKoniPlpForCampaignMobile() {
    if (typeof KoniPlp === 'undefined' || KoniPlp.__campaignMobilePatched) return;
    KoniPlp.__campaignMobilePatched = true;

    var originalBindFilters = KoniPlp.bindFilters.bind(KoniPlp);
    KoniPlp.bindFilters = function () {
      if (getListing() && isCampaignMobileFilters()) {
        bindCampaignMobileFilters();
        return;
      }
      return originalBindFilters();
    };

    var originalInitAccordion = KoniPlp.initKoniFilterAccordion.bind(KoniPlp);
    KoniPlp.initKoniFilterAccordion = function (section) {
      if (getListing() && isCampaignMobileFilters()) return;
      return originalInitAccordion(section);
    };
  }

  function refreshCampaignFilterShowMore(scope) {
    if (typeof KoniPlp === 'undefined' || typeof KoniPlp.setupFilterShowMore !== 'function') return;

    if (getListing() && isCampaignMobileFilters()) {
      var root = scope || document;
      root.querySelectorAll('.m-filter--widget.m-accordion--item').forEach(function (widget) {
        KoniPlp.setupFilterShowMore(widget);
        var btn = widget.querySelector('[data-koni-filter-show-more]');
        if (btn) {
          btn.onclick = null;
          updateCampaignShowMoreLabel(btn, widget);
        }
      });
      bindCampaignMobileFilterShowMore();
      return;
    }

    var root = scope || document;
    root.querySelectorAll('.m-filter--widget.m-accordion--item').forEach(function (widget) {
      KoniPlp.setupFilterShowMore(widget);
    });
  }

  function restoreCampaignFacetVisualState(form) {
    if (!form) return;

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.disabled = false;

      var label = input.closest('label');
      if (label) {
        label.classList.remove('m-facet--checkbox__disabled', 'm-facet--disabled');
      }
    });

    form.querySelectorAll('.m-filter--widget.m-accordion--item').forEach(function (widget) {
      widget.classList.remove('koni-plp-filter--expanded');
      widget.querySelectorAll('.m-facet--item').forEach(function (item) {
        item.classList.remove('koni-plp-facet--more', 'koni-plp-facet--revealed');
      });
    });

    refreshCampaignFilterShowMore(form);
  }

  function mergeFacetCountsFromDoc(doc) {
    var form = document.getElementById('CollectionFiltersForm');
    var newForm = doc && doc.getElementById('CollectionFiltersForm');
    if (!form || !newForm) return;

    newForm.querySelectorAll('input[type="checkbox"]').forEach(function (newInput) {
      if (!newInput.name) return;

      var currentInput = form.querySelector(
        'input[name="' + CSS.escape(newInput.name) + '"][value="' + CSS.escape(newInput.value) + '"]'
      );
      if (!currentInput) return;

      var newItem = newInput.closest('.m-facet--item');
      var currentItem = currentInput.closest('.m-facet--item');
      if (!newItem || !currentItem) return;

      var newCount = newItem.querySelector('.m-facet--product-count');
      var currentCount = currentItem.querySelector('.m-facet--product-count');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }

      currentInput.disabled = !!newInput.disabled;
      currentItem.classList.toggle('hidden', newItem.classList.contains('hidden'));

      var newLabel = newInput.closest('label');
      var currentLabel = currentInput.closest('label');
      if (newLabel && currentLabel) {
        currentLabel.classList.toggle(
          'm-facet--checkbox__disabled',
          newLabel.classList.contains('m-facet--checkbox__disabled')
        );
        currentLabel.classList.toggle('m-facet--disabled', newLabel.classList.contains('m-facet--disabled'));
      }
    });

    refreshCampaignFilterShowMore(form);
  }

  function syncCampaignDrawerChips() {
    if (!isCampaignMobileFilters()) return;

    ensureCampaignFilterDrawerChrome();

    var drawerHost = document.getElementById('CampaignDrawerFacets');
    if (!drawerHost) return;

    var chips = getPendingDrawerFilterChips();
    if (!chips.length) {
      drawerHost.innerHTML = '';
      drawerHost.classList.remove('has-filters');
      return;
    }

    drawerHost.classList.add('has-filters');
    drawerHost.innerHTML = buildDrawerFacetsHtml(chips);
  }

  function syncCampaignMobileFilterCascadesFromDoc(doc, pendingState) {
    if (!isCampaignMobileFilters() || !doc) return false;

    campaignPendingAccordionState = snapshotCampaignAccordionState();

    campaignPreviewCascadeInProgress = true;
    try {
      if (!injectFilterForm(doc, { fromMobilePreview: true })) {
        mergeFacetCountsFromDoc(doc);
        return false;
      }

      if (pendingState) {
        restoreCampaignFilterForm(pendingState);
      }

      refreshCampaignFilterShowMore(document.getElementById('CollectionFiltersForm'));
      if (getListing() && isCampaignMobileFilters()) {
        bindCampaignMobileFilters();
      } else if (typeof KoniPlp !== 'undefined' && typeof KoniPlp.bindFilters === 'function') {
        KoniPlp.bindFilters();
      }

      syncCampaignDrawerChips();
      return true;
    } finally {
      campaignPreviewCascadeInProgress = false;
    }
  }

  function setCampaignDrawerCount(count, isLoading) {
    var countEl = document.querySelector('.campaign-filter-drawer__count');
    if (!countEl) return;

    countEl.classList.toggle('is-loading', !!isLoading);
    if (isLoading) return;

    var displayCount = count !== null && count !== undefined && count !== '' ? count : '0';
    countEl.textContent = '(' + displayCount + ') Results';
  }

  function fetchCampaignPreviewData(searchParams) {
    var normalizedParams = normalizeCampaignSearchParams(searchParams);
    var catalogPath = resolveCatalogPath(normalizedParams);
    var urls = buildFetchUrls(catalogPath, normalizedParams);
    var requestId = ++campaignPreviewCountRequest;

    function tryFetch(index) {
      if (index >= urls.length) {
        return Promise.resolve({ count: '', doc: null });
      }

      return fetch(urls[index], { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load preview count');
          return res.text();
        })
        .then(function (html) {
          if (requestId !== campaignPreviewCountRequest) {
            return { count: '', doc: null };
          }
          var doc = parseFetchedHtml(html);
          if (!isValidCampaignPreviewDoc(doc)) {
            throw new Error('Preview markup missing');
          }
          return {
            count: parseCountFromFetchedDoc(doc),
            doc: doc
          };
        })
        .catch(function () {
          return tryFetch(index + 1);
        });
    }

    return tryFetch(0);
  }

  function fetchCampaignPreviewCount(searchParams) {
    return fetchCampaignPreviewData(searchParams).then(function (result) {
      return result.count || '';
    });
  }

  function updateCampaignDrawerPreviewCount() {
    if (!isCampaignMobileFilters()) return;

    var section = getSection();
    if (!section || !section.classList.contains('sidebar-open')) return;

    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;

    var searchParams = getFormFilterSearchParams(form);
    var instantCount = getInstantPreviewCountFromForm(form);
    var pendingChanged = pendingFiltersDifferFromApplied(form);

    if (instantCount && !pendingChanged) {
      setCampaignDrawerCount(instantCount, false);
    } else if (campaignLastPreviewCount && pendingChanged) {
      setCampaignDrawerCount(campaignLastPreviewCount, true);
    } else if (!pendingChanged) {
      var appliedTotal = parseResultsTotalCount();
      if (appliedTotal) {
        setCampaignDrawerCount(appliedTotal, false);
      } else {
        setCampaignDrawerCount(null, true);
      }
    } else {
      setCampaignDrawerCount(null, true);
    }

    var pendingState = snapshotCampaignFilterForm();

    fetchCampaignPreviewData(searchParams).then(function (result) {
      if (!isCampaignMobileFilters()) return;
      var sectionNow = getSection();
      if (!sectionNow || !sectionNow.classList.contains('sidebar-open')) return;

      // Only re-render the filter form when pending filters actually differ
      // from what's applied. Re-injecting on an unchanged form needlessly
      // resets "show more" expansions and accordion state.
      if (result.doc && pendingFiltersDifferFromApplied(form)) {
        syncCampaignMobileFilterCascadesFromDoc(result.doc, pendingState);
      }

      if (result.count !== '') {
        campaignLastPreviewCount = result.count;
        setCampaignDrawerCount(result.count, false);
      } else if (instantCount && !pendingFiltersDifferFromApplied(form)) {
        setCampaignDrawerCount(instantCount, false);
      } else if (campaignLastPreviewCount && pendingFiltersDifferFromApplied(form)) {
        setCampaignDrawerCount(campaignLastPreviewCount, false);
      } else if (!pendingFiltersDifferFromApplied(form)) {
        setCampaignDrawerCount(parseResultsTotalCount() || '0', false);
      } else {
        setCampaignDrawerCount(null, true);
      }
    });
  }

  function scheduleCampaignDrawerPreviewCount() {
    if (!isCampaignMobileFilters()) return;
    // Prevent an infinite loop: injecting the preview form re-runs
    // relocateCampaignFacets -> syncCampaignMobileFilterUi, which would
    // otherwise schedule another preview fetch on every cascade.
    if (campaignPreviewCascadeInProgress) return;
    clearTimeout(campaignPreviewCountTimer);
    campaignPreviewCountTimer = setTimeout(updateCampaignDrawerPreviewCount, 220);
  }

  function snapshotCampaignFilterForm() {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return null;

      var state = [];
      form.querySelectorAll('input, select, textarea').forEach(function (input) {
        if (!input.name) return;
        if (input.type === 'checkbox' || input.type === 'radio') {
          state.push({
            name: input.name,
            value: input.value,
            checked: input.checked,
            type: input.type
          });
        } else {
          state.push({
            name: input.name,
            value: input.value,
            type: input.type || 'text'
          });
        }
      });
      return state;
    }

    function restoreCampaignFilterForm(snapshot) {
      if (!snapshot) return;
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return;

      snapshot.forEach(function (item) {
        if (item.type === 'checkbox' || item.type === 'radio') {
          var input = form.querySelector(
            'input[name="' + CSS.escape(item.name) + '"][value="' + CSS.escape(item.value) + '"]'
          );
          if (input) input.checked = item.checked;
        } else {
          var field = form.querySelector('[name="' + CSS.escape(item.name) + '"]');
          if (field) field.value = item.value;
        }
      });
    }

    function applyCampaignFilterFormFromUrl(searchParams) {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return;

      var params = new URLSearchParams(searchParams || '');
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        if (!input.name) return;
        var values = params.getAll(input.name);
        input.checked = values.indexOf(input.value) !== -1;
      });
      form.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (!input.name) return;
        input.checked = params.get(input.name) === input.value;
      });
    }

    function applyCampaignMobileFilters() {
      var form = document.getElementById('CollectionFiltersForm');
      var filtersForm = document.querySelector('collection-filters-form');
      if (!form) return Promise.resolve();

      if (isCampaignMobileFilters()) {
        campaignPendingAccordionState = snapshotCampaignAccordionState();
      }

      var searchParams = new URLSearchParams(new FormData(form)).toString();
      campaignFilterApplying = true;
      if (filtersForm) filtersForm.__campaignApplyFiltersNow = true;

      return loadFilteredResults(normalizeCampaignSearchParams(searchParams), {
        pushState: true,
        scroll: false
      }).finally(function () {
        campaignFilterApplying = false;
        if (filtersForm) filtersForm.__campaignApplyFiltersNow = false;
        campaignFilterFormSnapshot = snapshotCampaignFilterForm();
        campaignLastPreviewCount = parseResultsTotalCount();
        syncCampaignMobileFilterUi();
      });
    }

    function ensureCampaignFilterDrawerChrome() {
      var sidebarContent = document.querySelector('.campaign-landing-plp .koni-plp-filters-sidebar__content');
      if (!sidebarContent) return;

      var header = sidebarContent.querySelector('.koni-plp-filters__header');
      var wrapper = sidebarContent.querySelector('.koni-plp-filters__wrapper');
      if (!header || !wrapper) return;

      var drawerHeader = sidebarContent.querySelector('.campaign-filter-drawer__header');
      if (!drawerHeader) {
        drawerHeader = document.createElement('div');
        drawerHeader.className = 'campaign-filter-drawer__header';

        var existingTop = sidebarContent.querySelector('.campaign-filter-drawer__top');
        var existingActive = sidebarContent.querySelector('.campaign-filter-drawer__active');

        if (existingTop) {
          drawerHeader.appendChild(existingTop);
        } else {
          var top = document.createElement('div');
          top.className = 'campaign-filter-drawer__top';
          top.innerHTML =
            '<p class="campaign-filter-drawer__count" aria-live="polite"></p>' +
            '<button type="button" class="campaign-filter-drawer__done" data-campaign-filter-done>Done</button>';
          drawerHeader.appendChild(top);
        }

        if (existingActive) {
          drawerHeader.appendChild(existingActive);
        } else {
          var activeHost = document.createElement('div');
          activeHost.className = 'campaign-filter-drawer__active';
          activeHost.id = 'CampaignDrawerFacets';
          drawerHeader.appendChild(activeHost);
        }

        sidebarContent.insertBefore(drawerHeader, header);
      }

      if (!drawerHeader.querySelector('.campaign-filter-drawer__top')) {
        var topBar = document.createElement('div');
        topBar.className = 'campaign-filter-drawer__top';
        topBar.innerHTML =
          '<p class="campaign-filter-drawer__count" aria-live="polite"></p>' +
          '<button type="button" class="campaign-filter-drawer__done" data-campaign-filter-done>Done</button>';
        drawerHeader.insertBefore(topBar, drawerHeader.firstChild);
      }

      if (!drawerHeader.querySelector('#CampaignDrawerFacets')) {
        var activeHost = document.createElement('div');
        activeHost.className = 'campaign-filter-drawer__active';
        activeHost.id = 'CampaignDrawerFacets';
        drawerHeader.appendChild(activeHost);
      }

      var doneBtn = sidebarContent.querySelector('[data-campaign-filter-done]');
      if (doneBtn && doneBtn.dataset.campaignDoneBound !== 'true') {
        doneBtn.dataset.campaignDoneBound = 'true';
        doneBtn.addEventListener('click', function () {
          applyCampaignMobileFilters().then(function () {
            closeCampaignMobileFilterDrawer({ skipRestore: true });
          });
        });
      }
    }

    function escapeHtmlAttr(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function getPendingDrawerFilterChips() {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return [];

      var chips = [];

      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
        if (!input.name || input.disabled) return;

        var labelEl = input.closest('.m-facet--checkbox');
        var labelNode = labelEl && labelEl.querySelector('.m-facet--label');
        var colorName = labelEl && labelEl.querySelector('.m-facet--color-name');
        var text = '';

        if (labelNode) {
          text = labelNode.textContent.trim();
        } else if (colorName) {
          text = colorName.childNodes[0] ? colorName.childNodes[0].textContent.trim() : colorName.textContent.trim();
        } else {
          text = input.value;
        }

        if (!text) return;

        chips.push({
          name: input.name,
          value: input.value,
          label: text
        });
      });

      form.querySelectorAll('.m-facets-price').forEach(function (priceEl) {
        var minInput = priceEl.querySelector('input[type="number"][name*="gte"], input[type="number"][name*="min"]');
        var maxInput = priceEl.querySelector('input[type="number"][name*="lte"], input[type="number"][name*="max"]');
        var minVal = minInput && minInput.value ? minInput.value : '';
        var maxVal = maxInput && maxInput.value ? maxInput.value : '';

        if (!minVal && !maxVal) return;

        var currency = priceEl.querySelector('.m-facets-price--field-currency');
        var symbol = currency ? currency.textContent.trim() : '£';
        var label = minVal && maxVal
          ? symbol + minVal + ' - ' + symbol + maxVal
          : minVal
            ? symbol + minVal + '+'
            : 'Up to ' + symbol + maxVal;

        chips.push({
          name: '__price__',
          value: (minInput && minInput.name) || (maxInput && maxInput.name) || '__price__',
          label: label,
          isPrice: true
        });
      });

      return chips;
    }

    function buildDrawerFacetsHtml(chips) {
      if (!chips.length) return '';

      var pills = chips.map(function (chip) {
        return (
          '<div class="m-active-facets--item">' +
          '<button type="button" class="campaign-drawer-facet-pill" data-filter-name="' + escapeHtmlAttr(chip.name) + '" data-filter-value="' + escapeHtmlAttr(chip.value) + '"' + (chip.isPrice ? ' data-filter-price="true"' : '') + '>' +
          FACET_REMOVE_ICON +
          '<span>' + escapeHtmlAttr(chip.label) + '</span>' +
          '</button>' +
          '</div>'
        );
      }).join('');

      pills +=
        '<div class="m-active-facets--item m-active-facets--item-remove-all">' +
        '<button type="button" class="campaign-drawer-facet-reset" data-campaign-drawer-reset-all>Reset all</button>' +
        '</div>';

      return '<div class="m-active-facets m-active-facets--drawer">' + pills + '</div>';
    }

    function clearCampaignDrawerFilterForm() {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return;

      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = false;
      });
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.value = '';
      });
      form.querySelectorAll('input[type="range"]').forEach(function (input) {
        input.value = input.min || '0';
      });

      restoreCampaignFacetVisualState(form);
    }

    function removeCampaignDrawerFilterChip(name, value, isPrice) {
      var form = document.getElementById('CollectionFiltersForm');
      if (!form) return;

      if (isPrice) {
        form.querySelectorAll('.m-facets-price input[type="number"]').forEach(function (input) {
          input.value = '';
        });
        return;
      }

      var input = form.querySelector(
        'input[name="' + CSS.escape(name) + '"][value="' + CSS.escape(value) + '"]'
      );
      if (input) input.checked = false;
    }

    function syncCampaignFilterDrawer() {
      if (!isCampaignMobileFilters()) return;

      ensureCampaignFilterDrawerChrome();

      var chips = getPendingDrawerFilterChips();
      if (!chips.length) {
        var form = document.getElementById('CollectionFiltersForm');
        restoreCampaignFacetVisualState(form);
        setCampaignDrawerCount(parseResultsTotalCount(), false);
      }

      scheduleCampaignDrawerPreviewCount();
      syncCampaignDrawerChips();
    }

    function syncCampaignMobileFilterUi() {
      syncCampaignFilterDrawer();
    }

    function openCampaignMobileFilterDrawer() {
      var section = getSection();
      if (!section) return;

      var sidebar = section.querySelector('.koni-plp-filters-sidebar');
      var content = section.querySelector('.koni-plp-filters-sidebar__content');
      if (!sidebar) return;

      campaignSuppressBackdropCloseUntil = Date.now() + 450;
      campaignFilterFormSnapshot = snapshotCampaignFilterForm();

      sidebar.style.display = 'block';
      section.classList.add('sidebar-open');

      requestAnimationFrame(function () {
        sidebar.style.setProperty('--m-bg-opacity', '0.5');
        if (content) content.style.transform = 'translateY(0)';
        syncCampaignFilterDrawer();
      });
    }

    function closeCampaignMobileFilterDrawer(options) {
      options = options || {};
      var section = getSection();
      if (!section) return;

      var sidebar = section.querySelector('.koni-plp-filters-sidebar');
      var content = section.querySelector('.koni-plp-filters-sidebar__content');
      if (!sidebar) return;

      section.classList.remove('sidebar-open');
      sidebar.style.removeProperty('--m-bg-opacity');
      if (content) content.style.transform = '';

      setTimeout(function () {
        if (!section.classList.contains('sidebar-open')) {
          sidebar.style.display = 'none';
        }
      }, 300);

      if (!options.skipRestore && !campaignFilterApplying && campaignFilterFormSnapshot) {
        restoreCampaignFilterForm(campaignFilterFormSnapshot);
      }
    }

    function bindCampaignMobileDrawerControls() {
      if (campaignMobileDrawerControlsBound) return;
      campaignMobileDrawerControlsBound = true;

      document.addEventListener(
        'click',
        function (event) {
          if (!isCampaignMobileFilters()) return;

          if (event.target.closest('.campaign-landing-plp .m-sidebar--open')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            openCampaignMobileFilterDrawer();
            return;
          }

          if (event.target.closest('.campaign-landing-plp .m-sidebar--close')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            closeCampaignMobileFilterDrawer();
          }
        },
        true
      );

      // Capture phase so we intercept the backdrop click BEFORE Collection's
      // own sidebar listener (which lives on the sidebar element in bubble phase).
      document.addEventListener(
        'click',
        function (event) {
          if (!isCampaignMobileFilters()) return;

          var section = getSection();
          if (!section || !section.classList.contains('sidebar-open')) return;

          var sidebar = section.querySelector('.koni-plp-filters-sidebar');
          if (!sidebar || event.target !== sidebar) return;

          // Always stop the event so Collection's backdrop close can't fire.
          event.preventDefault();
          event.stopImmediatePropagation();

          if (Date.now() < campaignSuppressBackdropCloseUntil) return;

          closeCampaignMobileFilterDrawer();
        },
        true
      );
    }

    function patchCollectionInstance(inst) {
      if (!inst || inst.__campaignCollectionPatched) return;
      inst.__campaignCollectionPatched = true;

      if (typeof inst.initFilters === 'function') {
        var originalInitFilters = inst.initFilters;
        inst.initFilters = function () {
          if (getListing() && isCampaignMobileFilters()) return;
          return originalInitFilters.call(this);
        };
      }

      if (typeof inst.openSidebarFilter === 'function') {
        var originalOpen = inst.openSidebarFilter;
        inst.openSidebarFilter = function () {
          if (getListing() && isCampaignMobileFilters()) {
            return openCampaignMobileFilterDrawer();
          }
          return originalOpen.call(this);
        };
      }

      if (typeof inst.closeSidebarFilter === 'function') {
        var originalClose = inst.closeSidebarFilter;
        inst.closeSidebarFilter = function () {
          if (getListing() && isCampaignMobileFilters()) {
            return closeCampaignMobileFilterDrawer();
          }
          return originalClose.call(this);
        };
      }
    }

    function patchCollectionForCampaignMobile() {
      if (typeof Collection === 'undefined') return;

      // Collection defines its methods as instance fields (init = () => {}),
      // so we must wrap construction to patch every new instance.
      if (!Collection.__campaignWrapped) {
        var OriginalCollection = Collection;
        var WrappedCollection = function () {
          var inst = new OriginalCollection();
          patchCollectionInstance(inst);
          return inst;
        };
        WrappedCollection.prototype = OriginalCollection.prototype;
        WrappedCollection.__campaignWrapped = true;
        OriginalCollection.__campaignWrapped = true;

        try {
          Collection = WrappedCollection;
        } catch (e) {}
        try {
          window.Collection = WrappedCollection;
        } catch (e) {}
      }

      if (typeof MinimogTheme !== 'undefined' && MinimogTheme.Collection) {
        patchCollectionInstance(MinimogTheme.Collection);
      }
    }

    function bindCampaignDrawerFacetClicks() {
      if (campaignDrawerClicksBound) return;
      campaignDrawerClicksBound = true;

      document.addEventListener('click', function (event) {
        if (!getListing() || !isCampaignMobileFilters()) return;

        var resetBtn = event.target.closest('[data-campaign-drawer-reset-all]');
        if (resetBtn) {
          event.preventDefault();
          clearCampaignDrawerFilterForm();
          syncCampaignFilterDrawer();
          return;
        }

        var pill = event.target.closest('.campaign-drawer-facet-pill');
        if (pill) {
          event.preventDefault();
          removeCampaignDrawerFilterChip(
            pill.dataset.filterName,
            pill.dataset.filterValue,
            pill.dataset.filterPrice === 'true'
          );
          syncCampaignFilterDrawer();
        }
      });
    }

    function bindCampaignDrawerFacetSync() {
      if (campaignDrawerFacetSyncBound) return;
      campaignDrawerFacetSyncBound = true;

      document.addEventListener('change', function (event) {
        if (!isCampaignMobileFilters()) return;
        if (!event.target.closest('#CollectionFiltersForm')) return;
        syncCampaignFilterDrawer();
      });
    }

    function bindCampaignDeferredFilters() {
      if (campaignDeferredFiltersBound) return;
      campaignDeferredFiltersBound = true;

      var section = getSection();
      if (!section) return;

      var observer = new MutationObserver(function () {
        if (!isCampaignMobileFilters()) return;

        var content = section.querySelector('.koni-plp-filters-sidebar__content');
        if (section.classList.contains('sidebar-open')) {
          if (content) content.style.transform = 'translateY(0)';
          syncCampaignFilterDrawer();
        } else if (content) {
          content.style.transform = '';
        }
      });
      observer.observe(section, { attributes: true, attributeFilter: ['class'] });
    }

    function initCampaignMobileFilterUi() {
      if (!getListing() || campaignMobileFilterUiBound) return;
      campaignMobileFilterUiBound = true;

      bindCampaignDrawerFacetClicks();
      bindCampaignDrawerFacetSync();
      bindCampaignDeferredFilters();
      bindCampaignMobileDrawerControls();
      patchCollectionForCampaignMobile();
      bindCampaignFilterAccordionToggles();
      patchKoniPlpForCampaignMobile();
      bindCampaignMobileFilterShowMore();
      ensureCampaignFilterDrawerChrome();
      syncCampaignMobileFilterUi();

      window.matchMedia(CAMPAIGN_MOBILE_MEDIA).addEventListener('change', function () {
        syncCampaignMobileFilterUi();
      });
    }

    function setHydrating(isHydrating) {
      var listing = getListing();
      if (!listing) return;
      listing.classList.toggle('is-hydrating', !!isHydrating);
      revealFilterSidebar();
    }

    function initFromStoredFilters() {
      var params = getDefaultHydrationParams();
      if (needsFilterHydration() || params) {
        setHydrating(true);
        return loadFilteredResults(params, {
          scroll: false
        }).finally(function () {
          setHydrating(false);
        });
      }
      setHydrating(false);
    }

    function init() {
      if (!getListing()) return;

      stripListingHash();
      removeDuplicateFilterScripts();
      revealFilterSidebar();

      if (!initialized) {
        initialized = true;
        bindPagination();
        bindFilterUiGuards();
        initCampaignMobileFilterUi();
        if (!rerenderBound) {
          rerenderBound = true;
          document.addEventListener('collection:rerendered', function () {
            relocateCampaignFacets();
            syncCampaignMobileFilterUi();
          });
        }
        initFromStoredFilters();
      }

      patchFilterComponent();
      bindCustomFilters();
      relocateCampaignFacets();
      dedupeActiveFacets();
      syncCampaignMobileFilterUi();
    }

    window.addEventListener('popstate', function (event) {
      if (!getListing()) return;
      var params = event.state && event.state.searchParams;
      loadFilteredResults(params || '', { scroll: false });
    });

    window.CampaignLanding = {
      init: init,
      scrollToListing: scrollToListing,
      loadFilteredResults: loadFilteredResults,
      applyVehicleSearch: applyVehicleSearch
    };

    patchFilterComponent();
    patchKoniPlpForCampaignMobile();
    patchCollectionForCampaignMobile();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', function () {
      patchFilterComponent();
      bindCustomFilters();
    });
  })();
